/**
 * DataSource: eventos do app na trilha de auditoria — GUPM-335.
 * -------------------------------------------------------------
 * Escreve pela RPC `registrar_evento_app` o que só o navegador sabe: tentativa
 * e falha de login, clique em "Sair", tela negada, exportação. A allowlist de
 * ações e de chaves é do BANCO — este módulo só transporta.
 *
 * Contrato: `registrar` NUNCA lança e NUNCA demora mais que `TEMPO_MAXIMO_MS`.
 * Registrar é efeito colateral; ele não pode impedir o login, atrasar o
 * redirecionamento para a Microsoft nem travar o "Sair". Falha vira
 * `console.warn` sem dado pessoal (a mensagem é do transporte, não do usuário).
 */

import { supabase } from '@/lib/supabase';
import type { AcaoEventoApp, DadosEventoApp } from '@/domain/auditoria/eventos-app';

/** Teto de espera. Acima disso o evento é abandonado e a ação segue. */
export const TEMPO_MAXIMO_MS = 1500;

export interface EventosAppDataSource {
  registrar<A extends AcaoEventoApp>(acao: A, dados: DadosEventoApp[A]): Promise<void>;
}

export const eventosApp: EventosAppDataSource = {
  async registrar(acao, dados) {
    const chamada = (async () => {
      try {
        const { error } = await supabase.rpc('registrar_evento_app', {
          p_acao: acao,
          p_dados: dados,
        });
        if (error) console.warn(`[eventos-app] ${acao} não registrado:`, error.message);
      } catch (e) {
        console.warn(`[eventos-app] ${acao} não registrado:`, (e as Error).message);
      }
    })();
    let timer: ReturnType<typeof setTimeout> | undefined;
    const teto = new Promise<void>((resolve) => {
      timer = setTimeout(resolve, TEMPO_MAXIMO_MS);
    });
    await Promise.race([chamada, teto]);
    clearTimeout(timer);
  },
};
